(function () {
 'use strict';
 const sizeOf = variant => {
  const parts = [...(variant.options || []), variant.option1, variant.option2, variant.option3, ...String(variant.title || '').split('/')];
  for (const part of parts) {
   const match = String(part || '').trim().match(/^(?:(?:EUR|EURO|EU|TALLA)\s*)?(3[4-9]|4[0-6])(?:[.,](5))?(?:\s*(?:EUR|EURO|EU))?$/i);
   if (match) return match[1] + (match[2] ? '.5' : '');
  }
  return '';
 };
 const brandOf = product => {
  const title = String(product.title || '').trim();
  const patterns = [
   ['BAPE', /^bape\b/i], ['Salomon', /^salomon\b/i], ['Hugo Boss', /^hugo\s*boss\b/i],
   ['Jordan', /^(?:jdan|jdn|jordan)\b/i], ['Nike', /^(?:nk|nike)\b|\bair force\b/i],
   ['Adidas', /^(?:adds|adidas)\b|\b(?:yeezy|yzy)\b/i], ['New Balance', /^(?:nb|new balance)\b/i],
   ['Puma', /^(?:pma|puma)\b/i], ['On Cloud', /^on\b/i], ['Louis Vuitton', /^(?:lv|louis vuitton)\b/i],
   ['Vans', /^(?:vns|vans)\b/i], ['D&G', /^(?:dg|d&g)\b/i], ['Off-White', /^(?:ow|off.white)\b/i],
   ['Dior', /^(?:dior|dr homme)\b/i], ['ASICS', /^(?:ascs|asics)\b/i], ['Versace', /^(?:vsace|versace)\b/i]
  ];
  for (const [brand, pattern] of patterns) if (pattern.test(title)) return brand;
  const aliases={bape:'BAPE',salomon:'Salomon',nike:'Nike',nk:'Nike',adidas:'Adidas',adds:'Adidas',jordan:'Jordan',jdn:'Jordan',jdan:'Jordan','new balance':'New Balance',nb:'New Balance',puma:'Puma',pma:'Puma','on cloud':'On Cloud',on:'On Cloud','louis vuitton':'Louis Vuitton',lv:'Louis Vuitton',vans:'Vans',vns:'Vans','dolce & gabbana':'D&G','d&g':'D&G',dg:'D&G','dol&gab':'D&G','off-white':'Off-White',ow:'Off-White',dior:'Dior',"d'or":'Dior',asics:'ASICS',ascs:'ASICS',versace:'Versace',vsace:'Versace','hugo boss':'Hugo Boss',skechers:'Skechers'};
  const tags=new Set((product.tags||[]).map(tag=>String(tag).trim().toLowerCase()));
  for (const [tag,brand] of Object.entries(aliases)) if(tags.has(tag))return brand;
  const types = {nk:'Nike',nike:'Nike','nk sb':'Nike',adds:'Adidas',nb:'New Balance',jdan:'Jordan',jdn:'Jordan',pma:'Puma',on:'On Cloud',lv:'Louis Vuitton',vns:'Vans',dg:'D&G',ow:'Off-White',"d'or":'Dior',ascs:'ASICS',bape:'BAPE',salomon:'Salomon',vsace:'Versace'};
  return types[String(product.product_type || '').toLowerCase().trim()] || aliases[String(product.product_type || '').toLowerCase().trim()] || '';
 };
 function choose(products, items, limit = 2) {
  const excludedIds = new Set(items.map(item => String(item.product_id)));
  const excludedHandles = new Set(items.map(item => item.handle));
  const contexts = items.filter(item => item.shoe === true && Number(item.quantity) > 0)
   .map(item => ({size:sizeOf(item.variant || {}),brand:brandOf(item),quantity:Number(item.quantity)})).filter(item => item.size);
  if (!contexts.length) return [];
  return products.filter(product => !excludedIds.has(String(product.id)) && !excludedHandles.has(product.handle))
   .map((product, index) => {
    const brand = brandOf(product);
    const variants = (product.variants || []).filter(variant => variant.available === true && Number(variant.price) > 0)
     .map(variant => {
      const size = sizeOf(variant);
      const matches = contexts.filter(context => context.size === size);
      const score = matches.length ? Math.max(...matches.map(context => (brand && context.brand === brand ? 1000 : 0) + Math.min(context.quantity,99))) : -1;
      return {variant,size,score};
     }).filter(variant => variant.score >= 0).sort((a,b) => b.score - a.score);
    return {product,index,brand,variants,score:variants[0]?.score ?? -1};
   }).filter(product => product.variants.length).sort((a,b) => b.score - a.score || a.index - b.index).slice(0,limit);
 }
 const engine = {sizeOf,brandOf,choose};
 if (typeof module === 'object' && module.exports) module.exports = engine;
 if (typeof window === 'undefined' || typeof document === 'undefined' || window.BuceDiscovery) return;
 window.BuceDiscovery = engine;
 let cached = null, pending = null, loadedAt = 0, revision = 0, scheduled = 0, observer = null;
 const rootUrl = window.Shopify?.routes?.root || '/';
 const money = amount => new Intl.NumberFormat(document.documentElement.lang || 'es-CO',{style:'currency',currency:window.Shopify?.currency?.active || 'COP',maximumFractionDigits:0}).format(amount).replace(/\s*COP\b/g,'');
 function element(tag, className, text) {
  const node = document.createElement(tag);
  if (className) node.className = className;
  if (text !== undefined) node.textContent = text;
  return node;
 }
 async function feed() {
  if (cached && Date.now()-loadedAt < 60000) return cached;
  if (pending) return pending;
  const controller = new AbortController(), timeout = setTimeout(() => controller.abort(),8000);
  pending = (async () => {
   const url = new URL(rootUrl,location.origin);url.searchParams.set('sections','buce-v2-shoe-feed');
   const preview = new URLSearchParams(location.search).get('preview_theme_id');if (preview) url.searchParams.set('preview_theme_id',preview);
   const response = await fetch(url,{credentials:'same-origin',cache:'no-store',signal:controller.signal});
   if (!response.ok) throw new Error('Discovery unavailable');
   const sections = await response.json();
   const doc = new DOMParser().parseFromString(sections['buce-v2-shoe-feed'] || '','text/html');
   const source = doc.querySelector('[data-buce-shoe-feed]');
   if (!source) throw new Error('Discovery unavailable');
   const products = JSON.parse(source.textContent);
   if (!Array.isArray(products)) throw new Error('Discovery unavailable');
   cached = products;loadedAt = Date.now();return products;
  })().finally(() => {clearTimeout(timeout);pending = null;});
  return pending;
 }
 function productUrl(product, variant) {
  const url = new URL(rootUrl+'products/'+encodeURIComponent(product.handle),location.origin);
  url.searchParams.set('variant',String(variant.id));return url.pathname+url.search;
 }
 function card(match, labels) {
  const first = match.variants[0], variant = first.variant, product = match.product;
  const card = element('article','buce-discovery-card buce-socks-nudge');
  const image = element('img');image.width = 160;image.height = 100;image.loading = 'lazy';image.alt = product.title;
  const imageSource = typeof product.images?.[0] === 'string' ? product.images[0] : product.images?.[0]?.src;
  if (imageSource && /^(https?:\/\/|\/)/i.test(imageSource)) image.src = imageSource;
  card.setAttribute('role','listitem');card.append(image);
  const body = element('div','buce-socks-nudge__body');
  const link = element('a','buce-discovery-title',product.title);link.href = productUrl(product,variant);link.title = product.title;
  const price = element('strong','',money(Number(variant.price)));price.setAttribute('data-buce-cart-current','');
  const comparison = element('div','buce-cart-offer-price');comparison.hidden = !(Number(variant.compare_at_price)>Number(variant.price));
  const before = element('del','',money(Number(variant.compare_at_price)||0));before.setAttribute('data-buce-offer-compare','');
  const percent = element('span','buce-cart-offer-badge','−'+Math.round((1-Number(variant.price)/Number(variant.compare_at_price))*100)+'%');percent.setAttribute('data-buce-offer-percent','');
  const saved = element('span','',labels.savings.replace('__AMOUNT__',money(Number(variant.compare_at_price)-Number(variant.price))));saved.setAttribute('data-buce-offer-savings','');
  comparison.append(before,percent,saved);
  const shipping = element('small','buce-discovery-shipping',labels.shipping);
  const control = element('div','buce-cart-quickadd');control.setAttribute('data-buce-cart-quickadd','');
  const select = element('select');select.setAttribute('data-buce-cart-variant','');select.dataset.offerSavingsLabel = labels.savings;
  select.setAttribute('aria-label',labels.choose.replace('__TITLE__',product.title));
  match.variants.forEach(({variant,size}) => {
   const option = element('option','',labels.size.replace('__SIZE__',size));option.value = String(variant.id);
   Object.assign(option.dataset,{offerPrice:String(Number(variant.price)*100),offerCompare:String((Number(variant.compare_at_price)||0)*100),offerMoney:money(Number(variant.price)),offerCompareMoney:money(Number(variant.compare_at_price)||0),offerSavingsMoney:money(Number(variant.compare_at_price)-Number(variant.price))});
   select.append(option);
  });
  select.addEventListener('change',() => {link.href = productUrl(product,{id:select.value});});
  const add = element('button','',labels.add);add.type = 'button';add.setAttribute('data-buce-cart-add','');add.setAttribute('aria-label',labels.add+' '+product.title);
  if(match.variants.length===1){select.hidden=true;const size=element('span','buce-rail-size',first.size);size.setAttribute('aria-label',labels.size.replace('__SIZE__',first.size));control.append(size);}
  control.append(select,add);body.append(link,price,comparison,shipping,control);card.append(body);return card;
 }
 function isOpen(node) {
  const drawer = node.closest('#t4s-mini_cart');
  return !drawer || drawer.getAttribute('aria-hidden') === 'false' || drawer.classList.contains('is--opened');
 }
 async function refresh() {
  const ticket = ++revision;
  const slots = [...document.querySelectorAll('[data-buce-discovery]')].filter(node => isOpen(node));
  if (!slots.length) return;
  for (const slot of slots) {
   let context;try {context = JSON.parse(slot.querySelector('[data-buce-discovery-context]').textContent);} catch {slot.hidden = true;continue;}
   if (!context.items?.some(item => item.shoe === true && sizeOf(item.variant))) {slot.hidden = true;continue;}
   try {
    const products = await feed();if (ticket !== revision || !slot.isConnected || !isOpen(slot)) return;
    const matches = choose(products,context.items,8);
    slot.querySelector('[data-buce-discovery-list]').replaceChildren(...matches.map(match => card(match,slot.dataset)));
    slot.hidden = !matches.length;window.BuceCartRails?.mount(slot);
   } catch(error) {if (ticket === revision) slot.hidden = true;console.warn('[Buce discovery]',error.message);}
  }
 }
 function schedule() {clearTimeout(scheduled);scheduled = setTimeout(refresh,120);}
 document.addEventListener('buce:cart-status',schedule);
 document.addEventListener('buce:cart-loading',() => {revision++;document.querySelectorAll('[data-buce-discovery]').forEach(node => {node.hidden = true;});});
 document.addEventListener('buce:cart-error',() => {revision++;document.querySelectorAll('[data-buce-discovery]').forEach(node => {node.hidden = true;});});
 document.addEventListener('click',event => {if (event.target.closest?.('[data-drawer-options],a[href*="/cart"]')) schedule();});
 function start() {
  const drawer = document.getElementById('t4s-mini_cart');
  if (drawer && !observer) {observer = new MutationObserver(schedule);observer.observe(drawer,{attributes:true,attributeFilter:['aria-hidden','class']});}
  schedule();
 }
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});else start();
 document.addEventListener('shopify:section:load',start);
 engine.refresh = schedule;
})();

